import { config } from 'config';
import { useHistory } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import {
    Background,
    TextError,
    TextVersion
} from './styled';
import {
    Card,
    Container,
    Loader,
    Text
} from 'mol-ui';
import React, { useEffect } from 'react';
import {
    useQuery,
    useSelector
} from 'hooks';

const { version } = config;

const ErrorVersion = () => {

    const { push } = useHistory();
    const { t } = useTranslation();
    const { dangerColor } = useTheme();
    const { redirect } = useQuery();
    const { version: platformVersion } = useSelector('account');

    useEffect(() => {
        if (parseInt(platformVersion, 10) === parseInt(version, 10)) {
            push(redirect ? decodeURI(redirect) : '/');
        }
    }, [platformVersion, redirect]);

    const versionText = `${ t('La versión de la plataforma actual') } (v${ version }) ${ t('no es compatible con la nueva') } (v${ platformVersion }).`;
    const text = t('Estamos instalando la nueva versión, en unos instantes lo redirigiremos hacia el ingreso');
    const adviceText = t('Si no puede acceder luego de un minuto, cierre la pestaña y vuelva a intentar. En caso contrario contacte a un administrador');

    return (
        <Background>
            <Card danger margin="0px" padding="20px">
                <Container alignItems="center" width="600px">
                    <TextVersion>!</TextVersion>
                    <TextError>{ t('Versión no actualizada') }</TextError>
                    <Text margin="10px 0px" textAlign="center">{ versionText }</Text>
                    <Text margin="10px 0px" textAlign="center">{ text }</Text>
                    <Text margin="10px 0px" textAlign="center">{ adviceText }</Text>
                    <Loader active color={ dangerColor } />
                </Container>
            </Card>
        </Background>
    );
};

export default ErrorVersion;
